require("./eye3d.js");

$(document).ready(function () {
	$('.vg-courses-oftalma--lections .btn-show-all').click(function () {
		let $container = $(this).closest('.vg-courses-oftalma--lections');
		$container.addClass('show');
		return false;
	});
});
